/** Submit only through the existing, server-gated contact endpoint. */
export async function postInquiry(values, fetcher = fetch) {
  const response = await fetcher("/api/contact", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(values),
  });
  if (!response.ok) throw new Error("Contact form unavailable");
}
